module.exports = __webpack_public_path__ + "img/liucheng.478309fb.png";